<template>
    <div v-if="owner" class="flex items-center gap-x-1.5 text-text min-w-0">
        <p v-if="showTitle" v-text="text + ':'" class="flex-shrink-0" />

        <div class="min-w-0 flex-1">
            <ModelPreviewTooltip
                v-if="owner"
                :imageSrc="modelImage"
                :modelClass="ownerModelClass"
                :modelName="modelName"
            >
                <Link
                    :href="linkObject.href"
                    :class="[
                        'underline-hover capitalize focus-style text-link',
                        { 'truncate block w-full': truncateTitle },
                    ]"
                    v-text="linkObject.text"
                />
            </ModelPreviewTooltip>
        </div>
    </div>
</template>

<script>
import { Link } from '@inertiajs/vue3'
import ModelPreviewTooltip from '@/Components/ModelComponents/ModelPreviewTooltip.vue'
export default {
    name: 'OwnerLink',
    components: {
        Link,
        ModelPreviewTooltip,
    },

    props: {
        owner: {
            type: Object,
            required: true,
        },
        title: {
            type: [String, null],
            default: null,
        },
        showTitle: {
            type: Boolean,
            default: true,
        },
        truncateTitle: {
            type: Boolean,
            default: true,
        },
    },

    computed: {
        text() {
            if (this.title) {
                return this.title
            }

            return this.$lang.get('Owned by')
        },

        ownerModelClass() {
            return this.owner.modelClass
        },

        modelName() {
            return this.owner.name
        },

        modelImage() {
            return this.owner.first_image?.preview_url
        },

        linkObject() {
            return {
                href: this.$getModelUrl(this.owner),
                text: this.owner.name,
            }
        },
    },
}
</script>
